<template>
  <div>
    <Navbar />
    <div class="container ">
      <div class="verify-container">
        <div class="form">
          <Logo class="logo text-primary fill-current" />
          <h3>Check your email</h3>
          <p class="mt-4">We've sent you a confirmation code to <b>{{user.email}}</b>. Enter the code now and build your kingdom.</p>
          <div class="input-div mt-2">
            <div>
              <vs-input
                v-validate="'required|digits:6'"
                name="verification code"
                label-placeholder="VERIFICATION CODE"
                size="large"
                v-model="verification_code"
                class="w-full mt-3"
                @keyup="charCounter"
                v-mask="'######'" 
                icon-pack="feather"
                icon="icon-code"
                icon-no-border/>
                <span class="text-primary text-sm float-right">{{counter}}/6</span>
                <span class="text-danger text-sm float-left">{{ errors.first('verification code') }}</span>
            </div>
            <vs-button class="mt-20" @click="verify(verification_code)" :disabled="!validateForm">Continue</vs-button>
          </div>
          <div id="div-with-loading" class="vs-con-loading__container">
            <p v-if="isResend" class="mt-6 verify-info">Keep this open while you check your email. Haven't receive our email? Try finding it in spam folder or <a @click="showRemaining">resend</a> it.</p>
            <p v-if="!isResend" class="mt-6 verify-info"> You may try resend again in <span v-if="displaySeconds !== -1" style="color:#F9278E">00:{{displaySeconds}}</span></p>
          </div>
        </div>  
      </div>
    </div>
  </div>
</template>

<script>
import Verification from './VerificationComponent';
import Navbar from '@/views/components/quicksend-navbar/Navbar.vue';
import Logo from '@/layouts/components/Logo.vue';
import { mapGetters } from 'vuex';
import auth from '@/services/authService';
import router from '@/router';

export default {
  data () {
    return {
      isResend: true,
      timer: 60000,
      counter: false,
      interval: null,
      displaySeconds: 0,
      verification_code: '',
      counter: 0,
    }
  },
  components: {
    Logo,
    Navbar,
  },
  computed: {
    ...mapGetters(['user']),

    user() {
      return this.$store.state.user;
    },
    validateForm () {
      return !this.errors.any() && this.verification_code !== ''
    },
    _seconds () {
      return 1000
    }
  },
  methods: {
    charCounter () {
      this.counter = this.verification_code.length
    },
    verify(code) {
      auth.verifyCode(code).then((response) => {
        this.$store.commit('user/UPDATE_USER_INFO', { onboard_step: 2 });
        router.push('/signup/details')
      }).catch(error => {
        console.log(error);
        this.$vs.notify({
          title: 'Verification Failed',
          text: "Invalid verification code",
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      });
    },
    startTimer() {
      auth.resendVerificationCode(this.user.id)
      .then(()=>{
        this.$vs.notify({
        title: 'Email Resent',
        text: 'Resend verification code successful.',
        iconPack: 'feather',
        icon: 'icon-email',
        color: 'success'
        })
      })
      .catch(() => {
        this.$vs.notify({
        title: 'Unable to Send',
        text: 'Email was not found',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
        })
      })
    },
    showRemaining() {
      this.startTimer()
      this.loading()
      this.isResend = false
      if(!localStorage.getItem('timer')){
        const futureResendTime = new Date().getTime() + this.timer
        localStorage.setItem('timer',futureResendTime)
      }
      const getFutureTime = localStorage.getItem('timer')
      const timer = setInterval(() => {
        const now = new Date().getTime()
        const difference = getFutureTime - now

        if(difference < 0) {
          clearInterval(timer)
          localStorage.removeItem('timer')
          this.isResend = true
        }
        
        const seconds = Math.floor(difference / this._seconds)

        this.displaySeconds = seconds < 10 ? '0' + seconds : seconds

      }, 1000)

    },
    loading () {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 0.6
      })
      setTimeout(()=> {
        this.$vs.loading.close('#div-with-loading > .con-vs-loading')
      }, 1500);
    },
    redirects (page_name) {
      this.$vs.loading()
      setTimeout(() => {
        this.$vs.loading.close()
        this.$router.push({name: page_name})
      }, 1000);
    }
  }
}
</script>

<style scoped>
.verify-info {
    text-align: center;
}

* {
    padding:0;
    margin: 0;
    box-sizing: border-box;
}

body {
  display:flex;
}

.container {
  margin: auto;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(3,1fr);
    grid-template-areas: ". form .";
    grid-gap: 10rem;
    padding: 0 2rem;
    
}

.verify-container {
    display: flex;
    place-items: center;
    text-align: center;
    background-color: #fff;
    border-radius: 10px;
    padding: 15px 25px;
    position: relative;
    width: 100%;
    z-index: 10;
    margin-top: 80px;
    margin-bottom: 30px;
    grid-area: form;
}

.form{
    width:360px;
}

.logo {
    width: 150px;
    place-items: center;
}

.input-div{
    display: grid;
    margin: 25px 0;
    padding: 5px 0;
}

.input-div > div {
    position: relative;
    height: 45px;
}


/* .input {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: none;
    outline: none;
    background: none;
    padding: 0.5rem 0.7rem;
    font-size: 1.2rem;
    color: #555555;
} */


a{
  color: #f9278e;
  cursor: pointer;
}

@media screen and (max-width: 1050px) {
    .container{
        grid-gap: 6rem;
    }
}

@media screen and (max-width: 1000px) {
    .form{
        width: 290px;
    }

    .form h3{
        font-size: 1.2rem;
    }
    /* .img img{
        width: 400px;
    } */
}

@media screen and (max-width: 900px) {
    .container{
        display: inherit;
    }
    .verify-container{
        justify-content: center;
    }
}
</style>
